import React, { FC } from 'react';

import { formatCurrencyInputWithCommas } from '../utilities/formatting';

import { TextInput, TextInputProps } from './TextInput';

/* CurrencyTextInput */
// wraps a normal TextInput, but formats incoming text to like a currency amount
// Retains format when passing value to form handler

export const CurrencyTextInput: FC<TextInputProps> = ({
  maxLength,
  prefixText,
  ...props
}) => {
  const handleCurrencyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange } = props;
    const { value } = e.target;
    const formattedCurrency = formatCurrencyInputWithCommas(value);
    e.target.value = formattedCurrency;
    onChange(e);
  };

  return (
    <TextInput
      {...props}
      type="tel"
      maxLength={maxLength || 13}
      prefixText={prefixText === '' ? undefined : '$'}
      onChange={handleCurrencyChange}
    />
  );
};
